const ASSET_HOST = process.env.REACT_APP_ASSETS_URL || 'https://lofi.vexcited.com/large';
const effects = [
    {
        type: 'fire',
        name: 'Campfire',
        url: ASSET_HOST + '/effects/campfire.mp3',
    },
    {
        type: 'forest',
        name: 'Forest',
        url: ASSET_HOST + '/effects/forest_night.mp3',
    },
    {
        type: 'rain_forest',
        name: 'Forest Rain',
        url: ASSET_HOST + '/effects/rain_forest.mp3',
    },
    {
        type: 'waves',
        name: 'Waves',
        url: ASSET_HOST + '/effects/waves.mp3',
    },
    {
        type: 'fan',
        name: 'Fan',
        url: ASSET_HOST + '/effects/fan.mp3',
    },
    {
        type: 'city',
        name: 'City traffic',
        url: ASSET_HOST + '/effects/city_traffic.mp3',
    },
    {
        type: 'storm',
        name: 'Summer Storm',
        url: ASSET_HOST + '/effects/summer_storm.mp3',
    },
    {
        type: 'rain_street',
        name: 'City Rain',
        url: ASSET_HOST + '/effects/rain_city.mp3',
    },
    {
        type: 'river',
        name: 'River',
        url: ASSET_HOST + '/effects/river.mp3',
    },
    {
        type: 'birds',
        name: 'Bird Chirping',
        url: ASSET_HOST + '/effects/birds.mp3',
    },
    {
        type: 'people',
        name: 'People Talking',
        url: ASSET_HOST + '/effects/people_talk_inside.mp3',
    },
    {
        type: 'wind',
        name: 'Wind',
        url: ASSET_HOST + '/effects/wind.mp3',
    },
    {
        type: 'ocean',
        name: 'Ocean',
        url: ASSET_HOST + '/effects/ocean.mp3',
    },
    {
        type: 'fireplace',
        name: 'Fireplace',
        url: ASSET_HOST + '/effects/fireplace.mp3',
    },
    {
        type: 'snow',
        name: 'Blizzard',
        url: ASSET_HOST + '/effects/snow.mp3',
    },
    {
        type: 'keyboard',
        name: 'Keyboard',
        url: ASSET_HOST + '/effects/keyboard.mp3',
    },
    {
        type: 'underwater',
        name: 'Underwater',
        url: ASSET_HOST + '/effects/underwater.mp3',
    },
    {
        type: 'space',
        name: 'Deep Space',
        url: ASSET_HOST + '/effects/deepspace.mp3',
    },
    // {
    //     type: 'train_rain',
    //     name: 'Window Rain',
    //     url: 'https://lofi-new.s3.us-east-2.amazonaws.com/Window+rain.mp3',
    // },
    // {
    //     type: 'train_noise',
    //     name: 'Train',
    //     url: 'https://lofi-new.s3.us-east-2.amazonaws.com/train.mp3',
    // },
];
const playlistsBase = {
    chill: [
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_1.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_2.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_3.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_4.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_5.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_6.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_7.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_8.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_9.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_10.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_11.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_12.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_13.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_14.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_15.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_16.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_17.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_18.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_19.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_20.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_21.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_22.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_23.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/chill/chill_24.mp3',
        },
    ],
    jazzy: [
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_1.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_2.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_3.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_4.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_5.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_6.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_7.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_8.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_9.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_10.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_11.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_12.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_13.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_14.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_15.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_16.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_17.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_18.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_19.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_20.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_21.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_22.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_23.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_24.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/jazzy/jazzy_25.mp3',
        },
    ],
    sleepy: [
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_1.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_2.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_3.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_4.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_4.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_5.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_6.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_7.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_8.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_9.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_10.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_11.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_12.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_13.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_14.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_15.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_16.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_17.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_18.mp3',
        },
        {
            url: ASSET_HOST + '/ogtracks/sleepy/sleepy_19.mp3',
        },
    ],
};
const alarms = [
    ASSET_HOST + '/alarms/Digital.mp3',
    ASSET_HOST + '/alarms/Easy+Tone.mp3',
    ASSET_HOST + '/alarms/Piano.mp3',
    ASSET_HOST + '/alarms/Ringtone.mp3',
    ASSET_HOST + '/alarms/Soft.mp3',
];
// Snapshot del catálogo original (se toma al cargar el módulo, antes de
// cualquier hidratación) para que el admin pueda "importar el catálogo actual".
const staticTracks = JSON.parse(JSON.stringify(playlistsBase));

// Hidrata las playlists desde el catálogo de la API (mutación in-place para
// preservar la referencia del objeto que el store ya capturó). Sólo reemplaza
// un mood si llega con tracks; si no, deja la semilla estática como fallback.
function hydrateTracks(apiTracks) {
    if (!apiTracks || typeof apiTracks !== 'object') return false;
    let any = false;
    for (const mood of Object.keys(playlistsBase)) {
        const list = apiTracks[mood];
        if (Array.isArray(list) && list.length) {
            // se AGREGAN a la playlist estática (dedup por url), no se reemplaza
            const seen = new Set(playlistsBase[mood].map((t) => t.url));
            for (const t of list) {
                if (t && t.url && !seen.has(t.url)) {
                    playlistsBase[mood].push({ url: t.url, title: t.title, artist: t.artist });
                    seen.add(t.url);
                }
            }
            any = true;
        }
    }
    return any;
}

export { playlistsBase, effects, alarms, hydrateTracks, staticTracks };
